import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ExternalLink, Handshake } from "lucide-react";
import { api } from "@/lib/api";
import { Brand, UserMenu } from "@/components/Shell";

function PartnerCard({ p, i, hi }) {
  return (
    <article id={p.id} data-testid={`partner-card-${p.id}`} style={{ animationDelay: `${i * 80}ms` }} className={`fade-scene flex flex-col rounded-3xl border bg-white/[0.04] p-6 backdrop-blur-xl transition-colors hover:border-fuchsia-300/40 ${hi ? "border-fuchsia-400/70 shadow-[0_0_30px_rgba(232,121,249,.35)]" : "border-white/10"}`}>
      {p.featured && <p className="mb-3 self-start rounded-full bg-fuchsia-500/20 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-fuchsia-200" data-testid="partner-featured-badge">Partner del mese</p>}
      <img src={p.logo_url} alt={`Logo ${p.name}`} className="h-20 w-20 rounded-2xl bg-white object-contain p-2" />
      <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.25em] text-fuchsia-300">{p.category}</p>
      <h2 className="mt-1 font-display text-lg font-bold text-white">{p.name}</h2>
      <p className="mt-2 flex-1 text-sm text-slate-300">{p.description}</p>
      {p.website && <a data-testid={`partner-link-${p.id}`} href={p.website} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-1 text-xs font-bold text-emerald-300 hover:text-emerald-200">Visita il sito <ExternalLink className="h-3.5 w-3.5" /></a>}
    </article>
  );
}

export default function PartnersPage() {
  const [items, setItems] = useState(null);
  const hash = useLocation().hash.slice(1);
  useEffect(() => {
    api.get("/partners").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  useEffect(() => {
    if (items && hash) document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [items, hash]);
  return (
    <div className="min-h-screen bg-[#120d16] text-white" data-testid="partners-page">
      <header className="flex items-center justify-between px-4 py-4 sm:px-8">
        <div className="flex items-center gap-3"><Link to="/cafe" data-testid="partners-back-btn" aria-label="Torna al Café" className="grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20"><ArrowLeft className="h-4 w-4" /></Link><span className="hidden rounded-2xl bg-white px-3 py-2 sm:block"><Brand /></span></div>
        <UserMenu compact />
      </header>
      <main className="mx-auto max-w-6xl px-4 pb-20 pt-10 sm:px-8">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-fuchsia-300"><Handshake className="h-4 w-4" /> Selvix Café</p>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl" style={{ textShadow: "0 0 18px rgba(232,121,249,.45)" }}>I nostri PARTNER</h1>
        <p className="mt-4 max-w-2xl text-sm text-slate-300 sm:text-base">Associazioni di categoria e pagine di settore che collaborano con Doctor Selvix.</p>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="partners-list">
          {items?.map((p, i) => <PartnerCard key={p.id} p={p} i={i} hi={p.id === hash} />)}
        </div>
        {items && !items.length && <p className="mt-10 text-sm text-slate-400" data-testid="partners-empty">Nessun partner pubblicato al momento.</p>}
      </main>
    </div>
  );
}
